import React, { useEffect, useCallback } from 'react';

export default function Lightbox({ photos, index, onClose, onChange }) {
  const photo = photos[index];
  const hasPrev = index > 0;
  const hasNext = index < photos.length - 1;

  const handleKey = useCallback((e) => {
    if (e.key === 'Escape') onClose();
    if (e.key === 'ArrowLeft' && hasPrev) onChange(index - 1);
    if (e.key === 'ArrowRight' && hasNext) onChange(index + 1);
  }, [index, hasPrev, hasNext, onClose, onChange]);

  useEffect(() => {
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [handleKey]);

  const tags = photo.photo_tags?.map(pt => pt.tags?.name).filter(Boolean) ?? [];

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 200,
        background: 'rgba(255,255,255,0.97)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Close */}
      <button
        onClick={onClose}
        style={{
          position: 'fixed',
          top: '1.5rem',
          right: '2rem',
          background: 'none',
          border: 'none',
          color: 'var(--ink-faint)',
          fontSize: '20px',
          cursor: 'pointer',
          lineHeight: 1,
          padding: '0.25rem',
        }}
      >
        ×
      </button>

      {/* Prev */}
      {hasPrev && (
        <button
          onClick={e => { e.stopPropagation(); onChange(index - 1); }}
          style={navBtn('left')}
        >
          ←
        </button>
      )}

      {/* Image */}
      <div onClick={e => e.stopPropagation()} style={{ position: 'relative' }}>
        <img
          src={photo.url}
          alt={photo.filename || ''}
          style={{
            maxHeight: '85vh',
            maxWidth: '85vw',
            objectFit: 'contain',
            display: 'block',
          }}
        />
        <div style={{
          marginTop: '1rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            {tags.map(tag => (
              <span key={tag} style={{
                fontSize: '11px',
                color: 'var(--ink-faint)',
              }}>
                {tag}
              </span>
            ))}
          </div>
          <span style={{ fontSize: '11px', color: 'var(--ink-faint)' }}>
            {index + 1} / {photos.length}
          </span>
        </div>
      </div>

      {/* Next */}
      {hasNext && (
        <button
          onClick={e => { e.stopPropagation(); onChange(index + 1); }}
          style={navBtn('right')}
        >
          →
        </button>
      )}
    </div>
  );
}

function navBtn(side) {
  return {
    position: 'fixed',
    top: '50%',
    [side]: '2rem',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    color: 'var(--ink-faint)',
    fontSize: '18px',
    cursor: 'pointer',
    padding: '1rem',
  };
}
